import React, { useState, useEffect } from "react";
import {
  TableCell,
  styled,
  CircularProgress,
  Divider,
  Stack,
  Button,
} from "@mui/material";
import moment from "moment";
import { formattedAmountWithoutAed } from "../../../../utils/CommonFunction";
import styles from "./styles";
import { useProposalContext } from "../..";
import { useNavigate } from "react-router-dom";
import { getApiData } from "../../../../utils/APIHelper";
import { Setting } from "../../../../utils/Setting";
import { isArray, isEmpty } from "lodash";
import { toast } from "react-toastify";
import ConfirmModel from "../../../../components/ConfirmModel";
import PaymentGroupModal from "../../../../components/PaymentGroupModal";
import { MdOutlineEdit, MdOutlineDelete } from "react-icons/md";
import { ReactComponent as SmallDhiramIcon } from "../../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../../utils/CurrencyUtils";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  textTransform: "capitalize",
  padding: "0 !important",
}));

const AddStyledButton = styled(Button)(({ theme }) => ({
  padding: ".5vh 1vw !important",
  boxShadow: "none !important",
  border: "none",
  fontSize: "16px !important",
  borderRadius: "10px !important",
  letterSpacing: "0",
  fontWeight: "500 !important",
  whiteSpace: "nowrap",
}));

const StyledButton = styled(Button)(({ theme }) => ({
  background: "#4D6BF6",
  color: "#ffffff",
  boxShadow: "none",
  border: "1px solid #4D6BF6",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

const GreyStyledButton = styled(Button)(({ theme }) => ({
  background: "#fff",
  color: "#0D0D0E",
  boxShadow: "none",
  border: "1px solid #D7D8D9",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

export default function PaymentGroups() {
  const { proposalDetails, setProposalDetails } = useProposalContext();
  const [selectedMilestone, setSelectedMilestone] = useState(null);
  const [selectedDeleteMilestone, setSelectedDeleteMilestone] = useState(null);
  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    if (proposalDetails && proposalDetails?.proposal_id) {
      getDetailsApiCall(proposalDetails?.proposal_id);
    }
  }, [proposalDetails?.proposal_id]);

  async function getDetailsApiCall(id) {
    setLoader(true);
    try {
      const response = await getApiData(
        `${Setting.endpoints.getProject}?proposal_id=${id}`,
        "GET",
        {}
      );
      if (
        response.success &&
        isArray(response?.data) &&
        !isEmpty(response?.data)
      ) {
        const data = response?.data[0];
        setProposalDetails(data);
      }
      setLoader(false);
    } catch (error) {
      console.log("error:===>>>", error);
      setLoader(false);
    }
  }

  const handlePrevious = () => {
    navigate(`/new-create-proposal/${proposalDetails?.proposal_id}/budget`);
  };

  const handleNext = () => {
    const allMilestonesLinked = proposalDetails?.milestone?.every((milestone) =>
      proposalDetails?.payment_groups?.some((group) =>
        group.milestones?.some((m) => m.id === milestone.id)
      )
    );

    if (allMilestonesLinked) {
      navigate(`/new-create-proposal/${proposalDetails?.proposal_id}/review`);
    } else {
      toast.error("All Milestones should have a payment group");
    }
  };

  const handleCloseModal = () => setSelectedMilestone(null);

  const handleModalClose = () => {
    navigate("/proposals");
  };

  async function handleConfirm() {
    console.log("selectedDeleteMilestone", selectedDeleteMilestone);
    setButtonLoader(true);
    try {
      const response = await getApiData(
        `${Setting.endpoints.newPaymentGroup}/${selectedDeleteMilestone?.group_id}`,
        "DELETE",
        {},
        { "Content-Type": "application/json" },
        true
      );
      toast.success("Milestone Deleted Successfully");
      setSelectedDeleteMilestone(null);
      getDetailsApiCall(proposalDetails?.proposal_id);
      setButtonLoader(false);
    } catch (error) {
      console.log("err===>", error);
    }
  }

  const isAllMilestonesLinked = () => {
    const linkedMilestoneIds = new Set(
      proposalDetails?.payment_groups?.flatMap((group) =>
        group.milestones.map((milestone) => milestone.id)
      )
    );
    return proposalDetails?.milestone?.every((milestone) =>
      linkedMilestoneIds.has(milestone.id)
    );
  };

  return (
    <div style={{ ...styles.container, ...styles.columnFlex, gap: "15px" }}>
      <h3 style={styles.heading}>Payment Groups</h3>
      {loader ? (
        <center>
          <CircularProgress />{" "}
        </center>
      ) : (
        <div style={{ ...styles.columnFlex, gap: "10px" }}>
          {proposalDetails?.payment_groups
            ?.filter((group) => group.milestones.length > 0)
            .map((group, idx) => (
              <React.Fragment key={group.group_id}>
                <div style={styles.budgetRow}>
                  <div style={{ ...styles.rowFlex, flex: 1 }}>
                    <span style={styles.small_sub_heading}>
                      {group?.group_name}
                    </span>
                  </div>{" "}
                  <div style={{ ...styles.columnFlex, flex: 1 }}>
                    <h3 style={styles.small_text}>Due Date</h3>
                    <div style={styles.small_sub_heading}>
                      {group?.due_date
                        ? moment(group?.due_date).format("MMM DD, YYYY")
                        : "-"}
                    </div>
                  </div>
                  <div style={{ ...styles.columnFlex, flex: 1 }}>
                    <h3 style={styles.small_text}>Amount</h3>
                    <div
                      style={{
                        ...styles.small_sub_heading,
                        ...styles.rowFlex,
                        gap: "5px",
                      }}
                    >
                      {group?.amount && renderCurrencyIcon('small')}
                      {formattedAmountWithoutAed(group?.amount)}
                    </div>
                  </div>
                  <div style={{ ...styles.rowFlex, flex: 0.3 }}>
                    <div style={{ ...styles.rowFlex }}>
                      <MdOutlineEdit
                        onClick={() => setSelectedMilestone(group)}
                        style={{
                          cursor: "pointer",
                          fontSize: "1.3rem",
                          color: "#0D0D0E",
                        }}
                      />
                      <MdOutlineDelete
                        style={{
                          cursor: "pointer",
                          fontSize: "1.3rem",
                          color: "#e54746",
                        }}
                        onClick={() => setSelectedDeleteMilestone(group)}
                      />
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ))}
        </div>
      )}
      <StyledTableCell>
        <AddStyledButton
          onClick={() => setSelectedMilestone({})}
          style={
            isAllMilestonesLinked() ? styles.disabledBtn : styles.milestoneBtn
          }
          disabled={isAllMilestonesLinked()}
        >
          + Add Payment Group
        </AddStyledButton>
      </StyledTableCell>
      {selectedMilestone && (
        <PaymentGroupModal
          isCreationOpen={Boolean(selectedMilestone)}
          visible={Boolean(selectedMilestone)}
          handleCloseCreation={handleCloseModal}
          selectedPaymentGroup={selectedMilestone}
          isEdit={Object.keys(selectedMilestone).length !== 0}
          milestones={proposalDetails?.milestone}
          paymentGroups={proposalDetails?.payment_groups}
          proposalId={proposalDetails?.proposal_id}
          getProjectDetails={getDetailsApiCall}
          setOuterButtonLoader={setButtonLoader}
        />
      )}

      {selectedDeleteMilestone && (
        <ConfirmModel
          visible={!!selectedDeleteMilestone}
          handleClose={() => setSelectedDeleteMilestone(null)}
          confirmation={handleConfirm}
          message={`Are you sure you want to delete ${selectedDeleteMilestone?.group_name}?`}
        />
      )}

      <Divider sx={{ width: "100%" }} />
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <GreyStyledButton onClick={handlePrevious}>
          {buttonLoader ? (
            <CircularProgress size={26} style={{ color: "#fff" }} />
          ) : (
            "Previous Step"
          )}
        </GreyStyledButton>

        <Stack
          alignItems="end"
          flexDirection="row"
          justifyContent="flex-end"
          gap="10px"
        >
          <GreyStyledButton onClick={handleModalClose}>Cancel</GreyStyledButton>
          <StyledButton variant="contained" onClick={handleNext}>
            {buttonLoader ? (
              <CircularProgress size={26} style={{ color: "#fff" }} />
            ) : (
              "Save & Continue"
            )}
          </StyledButton>{" "}
        </Stack>
      </Stack>
    </div>
  );
}
